/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Card,
  Col,
  Form,
  Input,
  Row,
  Spin,
  Tabs,
  DatePicker,
  Button,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Select from 'components/Select';
import CurrencyInput from 'components/CurrencyInput';
import FormSubmitControls from 'components/FormSubmitControls';

import { checkToken } from 'api/utils';
import { useSelector } from 'react-redux';
import { selectUser } from 'store/auth';

import { getEmpleadosConDatosOpFilteredPaginated, getEmpleadosFiltered } from 'api/estructuraOrganizacional/empleados';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getAdministracionDePlazas } from 'api/catalogos/admnistracionDePlazas';
import { getPlazas } from 'api/catalogos/plazas';
import { getPuestos } from 'api/catalogos/puestos';
import { getAreas, getTiposDeEmpleados } from 'api/catalogos';
import { getEstadosDeEmpleados } from 'api/estructuraOrganizacional/estadosDeEmpleados';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import { areaBuscar, normalizeData } from 'utils/normalizers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { onError } from 'utils/handlers';
import namePDF from 'components/PDF/namePDF';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import CustomSearch from 'components/customSearch';
import {
  getFirmantesConstanciaDeAportaciones,
  postFirmanteConstanciaDeAportaciones,
} from 'api/nominas/firmanteConstanciaDeAportaciones';
import descargarConstanciaDeAportaciones from 'api/nominas/constanciaDeAportaciones';
import FirmanteConstanciaDeAportaciones from './FirmanteConstanciaDeAportaciones';

const { TabPane } = Tabs;

const ConstanciaDeAportaciones = () => {
  const [loading, setLoading] = useState(false);
  const [allowPrint, setAllowPrint] = useState(false);
  const [empleados, setEmpleados] = useState([]);
  const [datosOperacionalesDeEmpleados, setDatosOperacionalesDeEmpleados] = useState([]);
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [tiposDeEmpleados, setTiposDeEmpleados] = useState([]);
  const [estadosDelEmpleado, setEstadosDelEmpleado] = useState([]);
  const [firmanteData, setFirmanteData] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState('consulta');
  const user = useSelector(selectUser);
  const [form] = Form.useForm();
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [open, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [baseURIPagination, setBaseURIPagination] = useState();
  const [selectedEmpleado, setSelectedEmpleado] = useState();
  const [empleadoId, setEmpleadoId] = useState();

  let baseURI = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  useEffect(() => {
    let mounted = true;
    const fetch = async () => {
      setLoading(true);
      await checkToken();
      const [
        _empleados,
        _datosOperacionalesDeEmpleados,
        _adminPlazas,
        _plazas,
        _puestos,
        _areas,
        _tiposDeEmpleados,
        _firmantesConstanciasDeAportaciones,
        _estadosDelEmpleado,
        _tipos_de_nominas_empleados,
      ] = await Promise.all([
        getEmpleadosFiltered(),
        getDatoOperacionalesDeEmpleados(),
        getAdministracionDePlazas(),
        getPlazas(),
        getPuestos(),
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        getTiposDeEmpleados(),
        getFirmantesConstanciaDeAportaciones(),
        getEstadosDeEmpleados(),
        getTiposDeNominasEmpleados(),
      ]);
      const normalizedURS = normalizeData(_areas);
      if (mounted) {
        setEmpleados(_empleados);
        setDatosOperacionalesDeEmpleados(formatReceived(_datosOperacionalesDeEmpleados));
        setAdminPlazas(_adminPlazas);
        setPlazas(_plazas);
        setPuestos(_puestos);
        setAreas(normalizedURS);
        setTiposDeEmpleados(_tiposDeEmpleados);
        setFirmanteData(_firmantesConstanciasDeAportaciones);
        setEstadosDelEmpleado(_estadosDelEmpleado);
        setTiposDeNominaEmpleado(_tipos_de_nominas_empleados);
        setLoading(false);
      }
    };
    fetch();
    return () => { mounted = false; };
  }, []);

  const onChangeEmpleado = async (val) => {
    if (val) {
      setLoading(true);
      const _empleado = empleados.find((e) => e.id === val);
      const _datosOperacionales = datosOperacionalesDeEmpleados.find((e) => e.empleado?.id === _empleado?.id);
      const _adminPlaza = adminPlazas.find((e) => e.empleado === _empleado?.id);
      const _plaza = plazas.find((e) => e.id === _adminPlaza?.plaza);
      const _puesto = puestos.find((e) => e.id === _plaza?.puesto);
      const _area = areaBuscar(_plaza?.area_content_id, areas)?.title;
      const _tipoEmpleado = tiposDeEmpleados.find((e) => e.id === _puesto?.tipo_empleado)?.descripcion;
      const _estatus = estadosDelEmpleado.find((e) => e.id === _empleado?.estado_del_empleado)?.descripcion;
      setEmpleadoId(val);
      form.setFieldsValue({
        rfc: _empleado?.RFC,
        puesto: _puesto?.descripcion,
        area_content_id: _area,
        tipo_de_empleado: _tipoEmpleado,
        fecha_de_alta: _datosOperacionales?.fecha_de_alta,
        fecha_de_baja: _datosOperacionales?.fecha_de_baja,
        sueldo_mensual: _datosOperacionales?.sueldo_mensual,
        estatus: _estatus,
      });
      if (!_area) {
        setAllowPrint(false);
      } else {
        setAllowPrint(true);
      }
    } else {
      form.resetFields();
      setAllowPrint(false);
    }
    setLoading(false);
  };

  const postFirmante = async () => {
    try {
      const _adminPlaza = adminPlazas?.find((e) => e.empleado === user?.empleado);
      const _plaza = plazas?.find((e) => e.id === _adminPlaza?.plaza);
      const puestoFirmante = puestos?.find((e) => e.id === _plaza?.puesto)?.id;
      const values = {
        usuario: user?.id,
        puesto: puestoFirmante,
        area: _plaza?.area,
        area_content_id: _plaza?.area_content_id,
      };
      await postFirmanteConstanciaDeAportaciones(values);
    } catch (err) {
      onError(
        err,
        setLoading,
      );
    }
  };

  const fetchFirmanteData = async () => {
    const _data = await getFirmantesConstanciaDeAportaciones();
    setFirmanteData(_data);
  };

  const onPrint = async () => {
    try {
      setLoading(true);
      const fechaHoraEmision = moment().format('DD/MM/YYYY');
      await postFirmante();
      const pdf = await descargarConstanciaDeAportaciones(empleadoId, user?.id, fechaHoraEmision);
      const _empleado = empleados?.find((empleado) => empleado?.id === empleadoId);
      const name = namePDF('Constancia de Aportaciones', _empleado);
      if (pdf) {
        const blob = new Blob([pdf], {
          type: 'application/pdf',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        link.click();
        await fetchFirmanteData();
      }
      setLoading(false);
    } catch (error) {
      onError(error, setLoading);
    }
  };

  const validateInput = async () => {
    setLoading(true);
    setSelectedEmpleado();
    const searchEmp = form.getFieldValue('empleado');
    if (!searchEmp) {
      setVisible(true);
      return setLoading(false);
    }
    const res = await getEmpleadosConDatosOpFilteredPaginated(`${baseURI}numero_de_empleado=${searchEmp};`);
    const result = res?.results[0];
    if (!res) {
      return setLoading(false);
    }
    const empleadoResult = result?.empleado;
    setSelectedEmpleado(empleadoResult);
    form.setFieldsValue({
      empleado: `${empleadoResult?.numero_de_empleado || ''} - ${empleadoResult?.nombre || ''} ${empleadoResult?.apellido_paterno || ''} ${empleadoResult?.apellido_materno || ''}`,
    });
    onChangeEmpleado(empleadoResult?.id);
    return setLoading(false);
  };

  const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
    setLoading(true);
    if (empId) {
      baseURI = `${baseURI}numero_de_empleado=${empId};`;
    }
    if (nombreEmp) {
      baseURI = `${baseURI}nombre=${nombreEmp};`;
    }
    if (apPatEmp) {
      baseURI = `${baseURI}apellido_paterno=${apPatEmp};`;
    }
    if (apMatEmp) {
      baseURI = `${baseURI}apellido_materno=${apMatEmp};`;
    }
    if (tipoNominaEmpleado) {
      baseURI = `${baseURI}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
    }
    setBaseURIPagination(baseURI);
    const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURI);
    setData(formatReceivedClone(_empleados));
    return setLoading(false);
  };

  const columnsEmpleado = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (empObject) => empObject?.numero_de_empleado,
    },
    {
      titleText: 'Nombre',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.nombre,
    },
    {
      titleText: 'Apellido Paterno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_paterno,
    },
    {
      titleText: 'Apellido Materno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_materno,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 300,
      render: (empObject) => {
        const adminPlazaEmp = adminPlazas?.find((admP) => admP?.empleado === empObject?.id);
        const plazaEmp = plazas?.find((pl) => pl?.id === adminPlazaEmp?.plaza);
        const puestoEmp = puestos?.find((p) => p?.id === plazaEmp?.puesto);
        return `${puestoEmp?.descripcion || ''}`;
      },
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 250,
      render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          title="Constancia de Aportaciones"
          extra={(
            <FormSubmitControls
              allowPrint={allowPrint}
              onPrint={() => onPrint()}
            />
          )}
          bordered={false}
        >
          <Tabs
            type="card"
            activeKey={currentTabKey}
            onChange={(val) => {
              form.resetFields();
              setAllowPrint(false);
              setCurrentTabKey(val);
            }}
          >
            <TabPane
              tab={(
                <span>
                  Consulta
                </span>
              )}
              key="consulta"
              forceRender
            >
              <Form
                layout="vertical"
                form={form}
                scrollToFirstError
                name="general"
              >
                  <Row gutter={10} style={{ paddingTop: '1rem' }}>
                    <Col xs={24} sm={24} md={8}>
                      <Row align="middle">
                        <Col xs={24} sm={24} md={24}>
                          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                              <Form.Item
                                label="No. y Nombre del Empleado"
                                name="empleado"
                                hasFeedback
                              >
                                  <Input
                                    allowClear
                                  />
                              </Form.Item>
                              <Button
                                loading={loading}
                                onClick={validateInput}
                                icon={<SearchOutlined />}
                                style={{
                                  width: '2.7rem',
                                  marginTop: '-2px',
                                }}
                              />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <CustomSearch
                      form={form}
                      open={open}
                      setVisible={setVisible}
                      modalTitle="Buscar Empleado"
                      firstInputLabel="No. de Empleado"
                      firstInputName="numero_de_empleado"
                      secondInputLabel="Nombre del Empleado"
                      secondInputName="nombre"
                      searchInputLabel="Apellido Paterno"
                      searchInputName="apellido_paterno"
                      thirdInputLabel="Apellido Materno"
                      thirdInputName="apellido_materno"
                      firstSelectLabel="Tipo de Nómina Empleado"
                      firstSelectName="tipo_de_nomina_empleado"
                      firstSelectDataSource={tiposDeNominaEmpleado}
                      inputsNeeded={3}
                      selectsNeeded={1}
                      paginatedTable
                      modalWidth={1400}
                      columns={columnsEmpleado}
                      baseURI={baseURIPagination}
                      setSelectedRow={setSelectedEmpleado}
                      onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
                      formatReceivedClone={formatReceivedClone}
                      data={data}
                      setData={setData}
                      searchData={searchData}
                      onChange={onChangeEmpleado}
                    />
                    {selectedEmpleado
                      ? (
                        form.setFieldsValue({
                          empleado: `${selectedEmpleado?.numero_de_empleado || ''} - ${selectedEmpleado?.nombre || ''} ${selectedEmpleado?.apellido_paterno || ''} ${selectedEmpleado?.apellido_materno || ''}`,
                        })
                      ) : null}
                    <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="rfc"
                          label="RFC"
                        >
                        <Input
                          disabled
                        />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="puesto"
                          label="Puesto"
                        >
                        <Input
                          disabled
                        />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="area_content_id"
                          label="Área"
                        >
                        <Select
                          disabled
                        />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_empleado"
                          label="Tipo de Empleado"
                        >
                        <Input
                          disabled
                        />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_de_alta"
                          label="Fecha de Alta"
                        >
                        <DatePicker
                          placeholder=""
                          format="DD/MM/YYYY"
                          disabled
                        />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_de_baja"
                          label="Fecha de Baja"
                        >
                        <DatePicker
                          placeholder=""
                          format="DD/MM/YYYY"
                          disabled
                        />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                        <CurrencyInput
                          name="sueldo_mensual"
                          label="Sueldo Mensual del Empleado"
                          disabled
                        />
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estatus"
                          label="Estatus"
                        >
                        <Select
                          disabled
                        />
                        </Form.Item>
                    </Col>
                  </Row>
              </Form>
            </TabPane>
            <TabPane
              tab={(
                <span>
                  Firmante
                </span>
              )}
              key="firmante"
              forceRender
            >
              <FirmanteConstanciaDeAportaciones
                firmanteData={firmanteData}
              />
            </TabPane>
          </Tabs>
        </Card>
      </Spin>
    </Row>
  );
};

export default ConstanciaDeAportaciones;
